// @import
import Alpine from "alpinejs";
import { store } from "../Scene.js";
import { EquipmentIndex } from "../types.js";

Alpine.directive("equipment-detail", (element, { modifiers }, { cleanup, effect }) => {
  const sceneId = modifiers[0] || "default";
  const scene = store.getScene(sceneId);
  if (!scene) return console.warn("Trying to access uninitizialized scene");

  const equipmentId = element.getAttribute("data-equipment") as EquipmentIndex;
  if (!equipmentId) return console.warn("Trying to access uninitizialized equipment detail");

  effect(() => {
    const addOrRemove = ["remove", "add"][Number(scene.activeEquipment === equipmentId)];
    element.classList[addOrRemove]("c-equipment-details--open");
  });
});
